<template>
	<div class="vx-row">
		<div class="vx-col w-full mb-5">
			<vx-card>
				<h1 class="m-0 mr-2">
					{{ $t("paymentDetails") }}
				</h1>

        <div v-if="(isEditing || !paymentDetailsExist)"
             :key="selectedType"
             class="edit-payment-details vx-col m-0 mr-2 mt-8">
			<div class="flex flex-col gap-4 w-1/5">

<!--					Payment Type Select -->
					<div class="payment-type w-full">
						<label class="vs-input--label">{{ $t('paymentType') }}</label>
						<div class="vs-con-input">
						</div>
						<v-select
							v-model="selectedType"
							v-validate="'required'"
							:reduce="item => item.value"
							label="name"
							name="type"
							:options="types"
							:dir="$vs.rtl ? 'rtl' : 'ltr'"
							:clearable="true"
							class="single-row-select"
							:placeholder="$t('selectPaymentType')"
						/>
						<span
							:class="{ 'text-transparent': !errors.first('type') }"
							class="text-danger text-sm">
									{{ $t('fieldFilledIncorrect') }}
						</span>
					</div>

<!--					 Fullname -->
					<div v-if="['bank_account_non_eu', 'bank_account_eu', 'payoneer'].includes(selectedType)" class="payment-fullname w-full">
						<vs-input
							v-model="fullname"
              :label="selectedType === 'payoneer' ? $t('recipientName') : $t('holderFullName')"
							name="fullName"
              v-validate="'required|min:3|regex:^[^0-9]+$'"
							class="w-full "
						/>
						<span
							:class="{ 'text-transparent': !errors.first('fullName') }"
							class="text-danger text-sm"
						>
									{{ $t('fieldFilledIncorrect') }}
						</span>
					</div>

<!--					IBAN-->
					<div v-if="['bank_account_non_eu', 'bank_account_eu'].includes(selectedType)" class="payment-iban w-full">
						<vs-input
							v-model="iban"
							:label="$t('iban')"
							name="iban"
							v-validate="'required|min:15|max:34'"
							class="w-full "
						/>
						<span
							:class="{ 'text-transparent': !errors.first('iban') }"
							class="text-danger text-sm"
						>
									{{ $t('fieldFilledIncorrect') }}
						</span>
					</div>

<!--					SWIFT-->
					<div v-if="['bank_account_non_eu'].includes(selectedType)" class="payment-swift w-full">
						<vs-input
							v-model="swift"
							:label="$t('swift')"
							name="swift"
              v-validate="'required|regex:^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$'"
							class="w-full "
						/>
						<span
							:class="{ 'text-transparent': !errors.first('swift') }"
							class="text-danger text-sm"
						>
									{{ $t('fieldFilledIncorrect') }}
						</span>
					</div>

<!--					Recipient's address-->
					<div class="payment-recipient-address w-full">

<!--						Country-->
						<div v-if="['bank_account_non_eu', 'payoneer'].includes(selectedType)">

              <label class="vs-input--label">{{ selectedType === 'payoneer' ? $t('recipientCountry') : $t('country') }}</label>
              <div class="vs-con-input">
              </div>
              <v-select
                  v-model="country"
                  :options="countries"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  label="name"
                  v-validate="'required'"
                  name="country"
                  :clearable="true"
                  class="single-row-select"
              />

              <span
                  :class="{ 'text-transparent': !errors.first('country') }"
                  class="text-danger text-sm"
              >
										{{ $t('fieldFilledIncorrect') }}
							</span>
            </div>

<!--						City-->
						<div v-if="['bank_account_non_eu'].includes(selectedType)">
							<vs-input
								v-model="city"
								:label="$t('city')"
								name="city"
								v-validate="'required|min:3|regex:^[A-Za-z0-9\\s\\-]+$'"
								class="w-full "
							/>
							<span
								:class="{ 'text-transparent': !errors.first('city') }"
								class="text-danger text-sm"
							>
										{{ $t('fieldFilledIncorrect') }}
							</span>
						</div>

<!--						Street Address-->
						<div v-if="['bank_account_non_eu'].includes(selectedType)">
							<vs-input
								v-model="street"
								:label="$t('street')"
								name="street"
								v-validate="'required|min:3|regex:^[A-Za-z0-9\\s\\-]+$'"
								class="w-full "
							/>
							<span
								:class="{ 'text-transparent': !errors.first('street') }"
								class="text-danger text-sm"
							>
										{{ $t('fieldFilledIncorrect') }}
							</span>
						</div>

<!--						House Number-->
						<div v-if="['bank_account_non_eu'].includes(selectedType)">
							<vs-input
								v-model="house_number"
								:label="$t('houseNumber')"
								name="houseNumber"
								v-validate="'required|regex:^[A-Za-z0-9\\s\\/\\-]+$'"
								class="w-full "
							/>
							<span
								:class="{ 'text-transparent': !errors.first('houseNumber') }"
								class="text-danger text-sm"
							>
										{{ $t('fieldFilledIncorrect') }}
							</span>
						</div>

<!--						Apartment number-->
						<div v-if="['bank_account_non_eu'].includes(selectedType)">
							<vs-input
								v-model="apartment_number"
								:label="$t('apartmentNumber')"
								name="apartmentNumber"
								v-validate="'required|regex:^[A-Za-z0-9\\s\\-]+$'"
								class="w-full "
							/>
							<span
								:class="{ 'text-transparent': !errors.first('apartmentNumber') }"
								class="text-danger text-sm"
							>
										{{ $t('fieldFilledIncorrect') }}
							</span>
						</div>

<!--						Postal code-->
						<div v-if="['bank_account_non_eu'].includes(selectedType)">
							<vs-input
								v-model="postal_code"
								:label="$t('postalCode')"
								name="postalCode"
								v-validate="'required|min:3|regex:^[A-Za-z0-9\\s\\-]+$'"
								class="w-full "
							/>
							<span
								:class="{ 'text-transparent': !errors.first('postalCode') }"
								class="text-danger text-sm"
							>
										{{ $t('fieldFilledIncorrect') }}
							</span>
						</div>

					</div>

<!--					Account email-->
					<div v-if="['mellow', 'payoneer'].includes(selectedType)" class="payment-payoneer w-full">
						<vs-input
							v-model="account_email"
              :label="selectedType === 'payoneer' ? $t('payoneerAccEmail') : $t('mellowAccEmail')"
							name="accountEmail"
							v-validate="'required|email'"
							class="w-full "
						/>
						<span
							:class="{ 'text-transparent': !errors.first('accountEmail') }"
							class="text-danger text-sm"
						>
										{{ $t('fieldFilledIncorrect') }}
							</span>
					</div>

<!--					Crypto USDT-->
					<div v-if="['crypto'].includes(selectedType)" class="payment-crypto w-full">

						<label class="vs-input--label">{{ $t('USDT') }}</label>
						<div class="vs-con-input">
						</div>
						<v-select
							v-model="crypto_type"
							:options="crypto_types"
							:dir="$vs.rtl ? 'rtl' : 'ltr'"
							:reduce="crypto => crypto.value"
							label="name"
							v-validate="'required'"
							name="usdt"
							:clearable="true"
							class="single-row-select"
						/>
						<span
							:class="{ 'text-transparent': !errors.first('usdt') }"
							class="text-danger text-sm"
						>
								  {{ errors.first('usdt') || $t('fieldFilledIncorrect') }}
								</span>
					</div>

					<div v-if="['crypto'].includes(selectedType)" class="payment-crypto w-full">
						<vs-input
							v-model="wallet_address"
							:label="$t('cryptoField')"
							name="wallet"
							v-validate="'required|usdt_address'"
							class="w-full "
						/>
						<span
							:class="{ 'text-transparent': !errors.first('wallet') }"
							class="text-danger text-sm"
						>
						  {{ errors.first('wallet') || $t('fieldFilledIncorrect') }}
						</span>
					</div>

			</div>

					<div v-if="selectedType" class="flex flex-end flex-wrap mb-3 my-5">
						<vs-button class="mr-5" @click="submit" >{{ $t('save') }}
						</vs-button>
						<vs-button color="warning" type="border" @click="handleCancel">{{ $t('cancel') }}</vs-button>
					</div>
		</div>

        <div v-else class="view-payment-details vx-col w-full m-0 mr-2 mt-8">

          <div class="grid gap-4 mb-6">

            <p v-if="selectedType"><strong>{{ $t('paymentType') }}:</strong> {{ showSelectedTypeName(selectedType) }}</p>
            <p v-if="fullname">
              <strong>{{ type.value === 'payoneer' ? $t('recipientName') : $t('holderFullName') }}:</strong>
              {{ fullname }}
            </p>
            <p v-if="iban"><strong>{{ $t('iban') }}:</strong> {{ iban }}</p>
            <p v-if="swift"><strong>{{ $t('swift') }}:</strong> {{ swift }}</p>
            <p v-if="account_email"><strong>{{ type.value === 'mellow' ? $t('mellowAccEmail') : $t('payoneerAccEmail') }}:</strong> {{ account_email }}</p>

			<div>
				<p v-if="crypto_type"><strong>{{ $t('USDT') }}:</strong> {{ crypto_type }}</p>
				<p v-if="wallet_address"><strong>{{ $t('cryptoField') }}:</strong> {{ wallet_address }}</p>
			</div>
            <!-- Recipient address -->
            <div>

              <p v-if="type.value === 'bank_account_non_eu'" class="pt-4 pb-4 "><strong>{{ $t('recipientAddress') }}:</strong></p>

              <p v-if="country"><strong>{{   type.value === 'payoneer' ? $t('recipientCountry') : $t('country') }}:</strong> {{ country }}</p>
              <p v-if="city"><strong>{{ $t('city') }}:</strong> {{ city }}</p>
              <p v-if="street"><strong>{{ $t('street') }}:</strong> {{ street }}</p>
              <p v-if="house_number"><strong>{{ $t('houseNumber') }}:</strong> {{ house_number }}</p>
              <p v-if="apartment_number"><strong>{{ $t('apartmentNumber') }}:</strong> {{ apartment_number }}</p>
              <p v-if="postal_code"><strong>{{ $t('postalCode') }}:</strong> {{ postal_code }}</p>
            </div>

          </div>

          <div class="flex flex-end">
            <vs-button color="primary" @click="handleEdit">{{ $t('edit') }}</vs-button>
          </div>

        </div>

      </vx-card>
		</div>
	</div>
</template>

<script>
import vSelect from 'vue-select'
import notifier from "../../../mixins/notifier";
import { Validator } from 'vee-validate';


export default {
	name: "EditAuthorPaymentDetails",
  mixins: [ notifier ],
	props: {
		author_id: { type: Number },
	},

	components: {
		'v-select': vSelect,
	},

	data() {
		return {
			isEditing: false,
			paymentDetailsExist: false,
			selectedType: null,
			selectedTypeName: '',
      		type: '',
			fullname: '',
			iban: '',
			swift: '',
			country: '',
			city: '',
			street: '',
			house_number: '',
			apartment_number: '',
			postal_code: '',
			account_email: '',
			wallet_address: '',
			crypto_type: '',
      data: '',
			backupData: {},
		};
	},

	async created() {
		const vm = this;

		Validator.extend('usdt_address', {
			getMessage(field) {
				return `Is not a valid address for selected crypto type.`;
			},
			validate(value) {
				const ethAddressRegex = /^0x[a-fA-F0-9]{40}$/;
				const trxAddressRegex = /^T[a-zA-Z0-9]{33}$/;

				const selectedCryptoType = vm.crypto_type;

				if (selectedCryptoType === 'ERC20') {
					return ethAddressRegex.test(value);
				}

				if (selectedCryptoType === 'TRC20') {
					return trxAddressRegex.test(value);
				}

				return false;
			}
		});

		this.countries = (await this.$http.get('/settings/get-countries')).data.data;
	},


	computed: {
		userRole() {
		  return this.$store.state.auth.role;
		},
		crypto_types() {
			return [
				{
					name: this.$t('TRC20'),
					value: 'TRC20',
				},
				{
					name: this.$t('ERC20'),
					value: 'ERC20',
				},
			]
		},
		types() {
			return [
				{
					name: this.$t('bankEU'),
					value: 'bank_account_eu',
				},
				{
					name: this.$t('bankNonEU'),
					value: 'bank_account_non_eu',
				},
				{
					name: this.$t('mellow'),
					value: 'mellow',
				},
				{
					name: this.$t('payoneer'),
					value: 'payoneer',
				},
				{
					name: this.$t('crypto'),
					value: 'crypto',
				},
			];
		},
    requiredFields() {
      switch (this.selectedType) {
        case 'bank_account_eu':
          return ['iban', 'fullName'];
        case 'bank_account_non_eu':
          return ['iban', 'fullName', 'swift', 'street', 'houseNumber', 'apartmentNumber', 'city', 'postalCode', 'country'];
        case 'mellow':
          return ['accountEmail'];
        case 'payoneer':
          return ['accountEmail', 'fullName', 'country'];
        case 'crypto':
          return ['wallet', 'usdt'];
        default:
          return [];
      }
    },
	},

  watch: {
    selectedType(newVal, oldVal) {
      if (this.isEditing && newVal !== oldVal) {
        this.resetPaymentFields();
        this.$nextTick(() => {
          this.$validator.pause();
          this.errors.clear();
          this.$validator.resume();
        });
      }
    }
  },


  methods: {
    resetPaymentFields() {

      this.fullname = '';
      this.iban = '';
      this.swift = '';
      this.account_email = '';
      this.wallet_address = '';
	  this.crypto_type = '';
      this.country = null;
      this.city = '';
      this.street = '';
      this.house_number = '';
      this.apartment_number = '';
      this.postal_code = '';

      const fields = ['fullname', 'iban', 'swift', 'account_email', 'wallet', 'usdt', 'country', 'city', 'street', 'house_number', 'apartment_number', 'postal_code'];
      fields.forEach(field => this.$validator.detach(field));
    },
    getRulesForField(field) {
      const rulesMap = {
        fullName: 'required|min:3|regex:^[^0-9]+$',
        iban: 'required|min:15|max:34',
        swift: 'required|regex:^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$',
        street: 'required|min:3|regex:^[A-Za-z0-9\\s\\-]+$',
        houseNumber: 'required|regex:^[A-Za-z0-9\\s\\/\\-]+$',
        apartmentNumber: 'required|regex:^[A-Za-z0-9\\s\\-]+$',
        city: 'required|min:3|regex:^[A-Za-z0-9\\s\\-]+$',
        postalCode: 'required|min:3|regex:^[A-Za-z0-9\\s\\-]+$',
        country: 'required',
        accountEmail: 'required|email',
		crypto_type: 'required',
        cryptoUSDT: 'required|usdt_address',
      };
      return rulesMap[field] || '';
    },

    async loadData() {
      try {
        let url = `/${this.userRole}/profile/payment-details`;

        if (this.userRole === 'admin' && this.author_id) {
          url += `?author_id=${this.author_id}`;
        }

        const res = await this.$http.get(url);
        const data = res.data.data;

        if (data && Object.keys(data).length > 0) {
          this.paymentDetailsExist = true;
          this.isEditing = false;
          this.originalData = { ...data };
          this.paymentDetails = data;

          const typeItem = this.types.find(item => item.value === data.type);
          this.selectedType = typeItem ? typeItem.value : '';

          this.type = typeItem;
          this.fullname = data.fullname;
          this.iban = data.iban;
          this.swift = data.swift;
          this.account_email = data.account_email;

			if (data.crypto_wallet_address) {
				Object.assign(this, data.crypto_wallet_address);
			}
          if (data.recipient_address) {
            Object.assign(this, data.recipient_address);
          }
        } else {
          this.paymentDetailsExist = false;
          this.isEditing = (this.userRole === 'author');
        }
      } catch (e) {
        console.error("Failed to load payment details", e);
      }
    },

    async submit() {
      this.errors.clear();

      const allFields = this.$validator.fields.items.map(f => f.name);

		const fieldsToDetach = allFields.filter(
			field => !this.requiredFields.includes(field)
		);

		fieldsToDetach.forEach(field => {
			const validatorField = this.$validator.fields.find({ name: field });
			if (validatorField) {
				this.$validator.detach(field);
			}
		});

		const isValid = await this.$validator.validateAll();

		fieldsToDetach.forEach(field => {
			const rules = this.getRulesForField(field);
			if (rules) {
				this.$validator.attach({ name: field, rules });
			}
		});


		if (!isValid) {
        this.errors.items.forEach(err => {
          console.log(`Field: ${err.field}, Message: ${err.msg || err.message}`);
        });
        this.notifyError(this.$t('fieldFilledIncorrect'));
        return;
      }
      let recipientAddress = null;
	  let cryptoDetails = null;

      if (this.selectedType === 'bank_account_non_eu') {
        recipientAddress = {
          country: this.country.name,
          city: this.city,
          street: this.street,
          house_number: this.house_number,
          apartment_number: this.apartment_number,
          postal_code: this.postal_code,
        };
      } else if (this.selectedType === 'payoneer') {
        recipientAddress = { country: this.country.name };
      }

	  if (this.selectedType === 'crypto') {
		  cryptoDetails = {
			  crypto_type: this.crypto_type,
			  wallet_address: this.wallet_address
		  }
	  }

      const payload = {
        type: this.selectedType,
        author_id: this.author_id,
        fullname: this.fullname,
        iban: this.iban,
        swift: this.swift,
        account_email: this.account_email,
        crypto_wallet_address: cryptoDetails,
        recipient_address: recipientAddress,
      };

      const url = `/${this.userRole}/profile/update-payment-method`;

      try {
        const response = await this.$http.post(url, payload);

          this.isEditing = false;
          this.paymentDetailsExist = true;
          await this.loadData();
          this.notifySuccess(this.$t('success'));
          return response.data;

      } catch (e) {
        this.notifyError(e.message || 'Request failed');
      }
    },
	  handleEdit() {
		  this.backupData = {
			  selectedType: this.selectedType,
			  fullname: this.fullname,
			  iban: this.iban,
			  swift: this.swift,
			  account_email: this.account_email,
			  crypto_type: this.crypto_type,
			  wallet_address: this.wallet_address,
			  country: this.country,
			  city: this.city,
			  street: this.street,
			  house_number: this.house_number,
			  apartment_number: this.apartment_number,
			  postal_code: this.postal_code,
		  };

		  this.isEditing = true;

		  const typeItem = this.types.find(item => item.value === this.originalData.type);
		  this.selectedType = typeItem ? typeItem.value : '';

		  this.fullname = this.originalData.fullname || '';
		  this.iban = this.originalData.iban || '';
		  this.swift = this.originalData.swift || '';
		  this.account_email = this.originalData.account_email || '';

		  if (this.originalData.recipient_address) {
			  const addr = this.originalData.recipient_address;
			  this.country = this.countries.find(c => c.name === addr.country) || null;
			  this.city = addr.city || '';
			  this.street = addr.street || '';
			  this.house_number = addr.house_number || '';
			  this.apartment_number = addr.apartment_number || '';
			  this.postal_code = addr.postal_code || '';
		  }

		  if (this.originalData.crypto_wallet_address) {
			  const addr = this.originalData.crypto_wallet_address;
			  this.crypto_type = addr.crypto_type || '';
			  this.wallet_address = addr.wallet_address || '';
		  }
	  },

	  async handleCancel() {
		  if (this.paymentDetailsExist) {

			  Object.assign(this, this.backupData);
			  this.isEditing = false;
		  } else {
			  this.selectedType = null;
			  this.fullname = '';
			  this.iban = '';
			  this.swift = '';
			  this.country = '';
			  this.city = '';
			  this.street = '';
			  this.house_number = '';
			  this.apartment_number = '';
			  this.postal_code = '';
			  this.account_email = '';
			  this.wallet_address = '';
			  this.crypto_type = '';
			  this.isEditing = true;
		  }
	  },
	  showSelectedTypeName() {
      const item = this.types.find(t => t.value === this.selectedType);
      return item ? item.name : '';
    },
  },

  mounted() {
    this.loadData();
  },

}
</script>

<style lang="scss">
h1 {
	font-size: 18px;
	color: #626262;
	margin-bottom: 15px;
	font-weight: 700;
}
.edit-payment-details {
	.v-select {
		margin-bottom: 0;
	}

}
</style>
